export default __webpack_public_path__ + "static/media/infrastracture-cloud-automation.9aaa77c7.jpg";